(function() {
  if (typeof jsProduct === 'undefined') return;
  var variants = jsProduct.variants || [];
  if (!variants.length) return;
  var optionConfig = window.sbaSalesOptions || {};
  var sizeIndex = typeof optionConfig.sizeOptionIndex === 'number' ? optionConfig.sizeOptionIndex : 0;
  var colorIndex = typeof optionConfig.colorOptionIndex === 'number' ? optionConfig.colorOptionIndex : 1;
  var addInFlight = false;
  var hasUserSelectedSize = false;
  var lastVariantUrl = '';
  var variantUrlTimer = null;

  function getSelectedSize() {
    var active = document.querySelector('.sba-sales-page .size-btn.active');
    return active ? active.dataset.size : '';
  }

  function getSelectedColor() {
    var active = document.querySelector('.sba-sales-page .color-swatch.active, .sba-sales-page .color-card.active');
    if (!active) return '';
    return active.title || active.dataset.color || '';
  }

  function getVariantOption(variant, index) {
    if (variant.options && variant.options[index]) return variant.options[index];
    return variant['option' + (index + 1)] || '';
  }

  function findVariant(size) {
    var color = getSelectedColor();
    var exactMatch = variants.find(function(v) {
      var sizeValue = getVariantOption(v, sizeIndex);
      var colorValue = getVariantOption(v, colorIndex);
      var sizeMatch = sizeValue && sizeValue.toUpperCase() === size.toUpperCase();
      var colorMatch = !color || !colorValue || colorValue.toLowerCase() === color.toLowerCase();
      return sizeMatch && colorMatch && v.available;
    });
    if (exactMatch) return exactMatch;

    return variants.find(function(v) {
      var sizeValue = getVariantOption(v, sizeIndex);
      return sizeValue && sizeValue.toUpperCase() === size.toUpperCase() && v.available;
    });
  }

  function getAvailableVariantForSize(size) {
    return findVariant(size);
  }

  function hasExplicitVariantSelection() {
    if (!window.location) return false;

    try {
      return Boolean(new URL(window.location.href).searchParams.get('variant'));
    } catch (error) {
      return /(?:^|[?&])variant=[^&]+/.test(window.location.search || '');
    }
  }

  function syncSizeAvailability() {
    var selectedSizeStillAvailable = false;
    var availableSizeCount = 0;
    var onlyAvailableSize = null;

    document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(btn) {
      var size = btn.dataset.size || btn.textContent.trim();
      var variant = getAvailableVariantForSize(size);
      var available = !!variant;

      btn.classList.toggle('oos', !available);
      btn.classList.toggle('disabled', !available);
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', String(!available));

      if (available) {
        availableSizeCount += 1;
        onlyAvailableSize = btn;
        if (btn.classList.contains('active')) selectedSizeStillAvailable = true;
      }
    });

    var mustChooseSize = availableSizeCount > 1 && !hasExplicitVariantSelection() && !hasUserSelectedSize;

    if (!selectedSizeStillAvailable || mustChooseSize) {
      document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      });

      if (!mustChooseSize && availableSizeCount === 1 && onlyAvailableSize) {
        onlyAvailableSize.classList.add('active');
        onlyAvailableSize.setAttribute('aria-pressed', 'true');
      }
    }
  }

  function getAddBtns() {
    var btns = document.querySelectorAll('.sba-sales-page [id$="AddToCart"], .sba-sales-page .cta-chrome, .sba-sales-page .sticky-bar-cta');
    var result = [];
    btns.forEach(function(b) {
      if (b.textContent.toLowerCase().includes('add to bag') || b.textContent.toLowerCase().includes('add to cart') || b.id.includes('AddToCart')) {
        result.push(b);
      }
    });
    return result;
  }

  function setButtonText(btn, text) {
    var label = btn.querySelector('[data-label], .sticky-label, .label');
    if (label) {
      label.dataset.label = text;
      label.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function getButtonText(btn) {
    var label = btn.querySelector('[data-label], .sticky-label, .label');
    return label ? label.textContent : btn.textContent;
  }

  function setAddButtonsBusy(addBtns, busy) {
    addBtns.forEach(function(b) {
      if (busy) {
        b.dataset.inflight = 'true';
        b.setAttribute('aria-busy', 'true');
        b.setAttribute('aria-disabled', 'true');
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.6';
      } else {
        delete b.dataset.inflight;
        b.removeAttribute('aria-busy');
        b.removeAttribute('aria-disabled');
        b.style.pointerEvents = '';
        b.style.opacity = '1';
      }
    });
  }

  function restoreAddButtons(addBtns) {
    (addBtns || getAddBtns()).forEach(function(b) {
      setButtonText(b, b.dataset.origText || 'Add To Cart');
      if (b.id === 'mobileStickyAtc') { var _s = getSelectedSize(); setButtonText(b, _s ? 'Add To Cart \u00b7 ' + _s : 'Add To Cart'); }
      delete b.dataset.origText;
      delete b.dataset.sbaAtcError;
      b.removeAttribute('aria-disabled');
      b.style.pointerEvents = '';
      b.style.opacity = '1';
    });
  }

  function shakeSizeButtons() {
    document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(b) {
      b.classList.add('shake');
      setTimeout(function() { b.classList.remove('shake'); }, 600);
    });
  }

  function getSizeRow() {
    var first = document.querySelector('.sba-sales-page .size-btn');
    return document.querySelector('.sba-sales-page #size-fit') || (first ? first.parentElement : null);
  }

  function getFirstAvailableSizeButton() {
    return document.querySelector('.sba-sales-page .size-btn:not(.oos):not(.disabled):not([disabled])');
  }

  function getSizeStatus() {
    var page = document.querySelector('.sba-sales-page');
    if (!page) return null;

    var status = page.querySelector('[data-sba-size-status]');
    if (status) return status;

    status = document.createElement('span');
    status.className = 'visually-hidden';
    status.dataset.sbaSizeStatus = 'true';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'assertive');
    status.setAttribute('aria-atomic', 'true');

    var sizeRow = getSizeRow();
    if (sizeRow && sizeRow.parentNode) {
      sizeRow.parentNode.insertBefore(status, sizeRow.nextSibling);
    } else {
      page.appendChild(status);
    }

    return status;
  }

  function clearSizeRequiredState() {
    var sizeRow = getSizeRow();
    var status = document.querySelector('.sba-sales-page [data-sba-size-status]');
    if (sizeRow) sizeRow.removeAttribute('aria-invalid');
    if (status) status.textContent = '';
  }

  function announceSizeRequired() {
    var sizeRow = getSizeRow();
    var status = getSizeStatus();
    if (sizeRow) sizeRow.setAttribute('aria-invalid', 'true');
    if (!status) return;

    status.textContent = '';
    window.requestAnimationFrame(function() {
      status.textContent = 'Select a size before adding to cart.';
    });
  }

  function focusFirstAvailableSize() {
    var first = getFirstAvailableSizeButton();
    if (!first || typeof first.focus !== 'function') return;

    try {
      first.focus({ preventScroll: true });
    } catch (error) {
      first.focus();
    }
  }

  function revealSizeRow() {
    var row = getSizeRow();
    var visible = false;

    announceSizeRequired();

    if (row && row.getBoundingClientRect) {
      var rect = row.getBoundingClientRect();
      visible = rect.top >= 0 && rect.bottom <= window.innerHeight - 90;
      if (!visible && row.scrollIntoView) {
        row.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    window.setTimeout(function() {
      shakeSizeButtons();
      focusFirstAvailableSize();
    }, visible ? 0 : 420);
  }

  function getAddErrorText(error) {
    var message = error && error.message ? error.message : '';
    var normalized = message.toLowerCase();

    if (normalized.includes('cart') || normalized.includes('section')) return 'cart syncing';
    if (normalized.includes('sold out') || normalized.includes('unavailable')) return 'sold out';
    if (normalized.includes('quantity') || normalized.includes('maximum')) return 'limit reached';
    return 'try again';
  }

  function buildCartFormData(variant) {
    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', '1');
    return formData;
  }

  function fallbackAddToCart(formData) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
    .then(function(r) {
      return r.text().then(function(text) {
        var response;
        try {
          response = text ? JSON.parse(text) : {};
        } catch(e) {
          throw new Error('Cart temporarily unavailable');
        }
        if (!r.ok || response.status) throw new Error(response.description || response.message || 'Could not add item');
        return response;
      });
    })
    .then(function(response) {
      if (window.SBACart && typeof window.SBACart.open === 'function') window.SBACart.open();
      return response;
    });
  }

  function addToCart(triggerEl) {
    if (addInFlight) return;
    var size = getSelectedSize();
    if (!size) {
      revealSizeRow();
      return;
    }
    var variant = findVariant(size);
    if (!variant) {
      var soldOutBtns = getAddBtns();
      soldOutBtns.forEach(function(b) {
        if (!b.dataset.origText) b.dataset.origText = getButtonText(b);
        setButtonText(b, 'sold out');
        b.setAttribute('aria-disabled', 'true');
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.6';
      });
      return;
    }

    var addBtns = getAddBtns();
    addInFlight = true;
    addBtns.forEach(function(b) {
      if (!b.dataset.origText) b.dataset.origText = getButtonText(b);
      setButtonText(b, 'adding...');
    });
    setAddButtonsBusy(addBtns, true);

    var formData = buildCartFormData(variant);
    var addPromise = window.SBACart && typeof window.SBACart.add === 'function'
      ? window.SBACart.add(formData, {
          trigger: triggerEl || addBtns[0],
          source: 'sba-pdp',
          detail: { product: jsProduct, variant: variant }
        })
      : fallbackAddToCart(formData);

    addPromise
    .then(function(item) {
      addBtns.forEach(function(b) {
        b.style.opacity = '1';
        setButtonText(b, 'added');
      });
      setTimeout(function() {
        restoreAddButtons(addBtns);
      }, 2000);
      if (window.CandyRack) try { window.CandyRack.onItemAdded(item); } catch(e) {}
    })
    .catch(function(error) {
      var errorText = getAddErrorText(error);
      addBtns.forEach(function(b) {
        b.style.opacity = '1';
        b.dataset.sbaAtcError = error && error.message ? error.message : errorText;
        setButtonText(b, errorText);
      });
      setTimeout(function() {
        restoreAddButtons(addBtns);
      }, 2000);
    })
    .finally(function() {
      addInFlight = false;
      setAddButtonsBusy(addBtns, false);
    });
  }

  /* Sep 22 2026 [Fable] — sticky bar: with no size picked, open the size chips above the bar instead of
     scrolling the page up. A chip tap = picks that size on the main row + adds. Adds from the bar are
     attributed as trigger 'mobile_sticky' [they used to be relabelled 'hero' via primary.click()]. */
  function getStickyChips() {
    return document.getElementById('mobileStickySizes');
  }
  function setChips(open) {
    var chips = getStickyChips();
    if (!chips) return;
    chips.hidden = !open;
    var sticky = document.getElementById('mobileStickyAtc');
    if (sticky) sticky.classList.toggle('is-picking', !!open);
    if (open) syncChipActive();
  }
  function syncChipActive() {
    var s = getSelectedSize();
    document.querySelectorAll('.mobile-sticky-size').forEach(function(c) {
      c.classList.toggle('is-active', !!s && c.dataset.size === s);
    });
  }
  function syncStickyLabel() {
    var sticky = document.getElementById('mobileStickyAtc');
    if (!sticky || sticky.dataset.inflight === 'true') return;
    var s = getSelectedSize();
    var text = s ? 'Add To Cart \u00b7 ' + s : 'Add To Cart';
    setButtonText(sticky, text);
    sticky.dataset.origText = text;
  }
  function pickSizeFromChip(size) {
    var main = document.querySelector('.sba-sales-page .size-btn[data-size="' + size + '"]');
    if (main && !main.disabled && !main.classList.contains('oos')) {
      main.click();
      if (!main.classList.contains('active')) {
        document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
        main.classList.add('active');
        main.setAttribute('aria-pressed', 'true');
      }
      return true;
    }
    return false;
  }
  function bindMobileStickyAtc() {
    document.querySelectorAll('.sba-sales-page .mobile-sticky-atc, .sba-sales-page #mobileStickyAtc').forEach(function(btn) {
      if (btn.dataset.sbaStickyAtcBound === 'true') return;
      btn.dataset.sbaStickyAtcBound = 'true';
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var size = getSelectedSize();
        var chips = getStickyChips();
        if (!size && chips) {
          setChips(chips.hidden);
          return;
        }
        if (!size) {
          revealSizeRow();
          return;
        }
        setChips(false);
        addToCart(btn);
      }, true);
    });
    var chips = getStickyChips();
    if (chips && chips.dataset.sbaBound !== 'true') {
      chips.dataset.sbaBound = 'true';
      chips.addEventListener('click', function(event) {
        var close = event.target.closest('[data-sticky-sizes-close]');
        if (close) { event.preventDefault(); setChips(false); return; }
        var chip = event.target.closest('.mobile-sticky-size');
        if (!chip || chip.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        if (!pickSizeFromChip(chip.dataset.size || '')) return;
        syncChipActive();
        syncStickyLabel();
        setChips(false);
        addToCart(document.getElementById('mobileStickyAtc'));
      });
      document.addEventListener('click', function(event) {
        if (chips.hidden) return;
        if (event.target.closest('#mobileStickySizes, #mobileStickyAtc')) return;
        setChips(false);
      });
    }
    syncStickyLabel();
  }

  function updateUrlVariant(size) {
    var variant = findVariant(size);
    if (!variant || !window.history || !window.URLSearchParams) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    var nextUrl = url.toString();
    if (nextUrl === lastVariantUrl) return;
    window.clearTimeout(variantUrlTimer);
    variantUrlTimer = window.setTimeout(function() {
      window.history.replaceState({}, '', nextUrl);
      lastVariantUrl = nextUrl;
    }, 120);
  }

  function bindSalesAtc() {
    syncSizeAvailability();

    /* Aug 22 2026: removed the auto-activation of a default size on load — ADD TO CART now asks for a size instead */

    document.querySelectorAll('.sba-sales-page [id$="AddToCart"], .sba-sales-page .cta-chrome, .sba-sales-page .sticky-bar-cta').forEach(function(btn) {
      if (btn.dataset.sbaAtcBound === 'true') return;
      if (btn.textContent.toLowerCase().includes('add to bag') || btn.textContent.toLowerCase().includes('add to cart') || btn.id.includes('AddToCart')) {
        btn.dataset.sbaAtcBound = 'true';
        btn.removeAttribute('href');
        btn.style.cursor = 'pointer';
        btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); addToCart(); });
      }
    });

    document.querySelectorAll('.sba-sales-page .size-btn:not(.oos):not(.disabled):not([disabled])').forEach(function(btn) {
      if (btn.dataset.sbaSizeBound === 'true') return;
      btn.dataset.sbaSizeBound = 'true';
      btn.addEventListener('click', function() {
        hasUserSelectedSize = true;
        clearSizeRequiredState();
        restoreAddButtons();
        updateUrlVariant(btn.dataset.size || '');
        setTimeout(function() { syncStickyLabel(); syncChipActive(); }, 0);
      });
    });

    bindMobileStickyAtc();
  }

  bindSalesAtc();
  document.addEventListener('shopify:section:load', bindSalesAtc);
})();

(function() {
  var page = document.querySelector('.sba-sales-page');
  if (!page) return;

  var tracks = Array.prototype.slice.call(page.querySelectorAll('.gallery-track'));
  if (!tracks.length) return;

  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : { matches: true };

  function getSource(img) {
    return img.currentSrc || img.src || (img.dataset && (img.dataset.src || img.dataset.original)) || '';
  }

  function primeImage(img, highPriority) {
    if (!img) return;
    img.loading = 'eager';
    img.setAttribute('loading', 'eager');
    if (!img.decoding) img.decoding = 'async';
    if ('fetchPriority' in img) img.fetchPriority = highPriority ? 'high' : 'auto';

    if (img.dataset.sbaPrimed === 'true') {
      if (img.decode) img.decode().catch(function() {});
      return;
    }
    img.dataset.sbaPrimed = 'true';

    var source = getSource(img);
    if (!source) return;

    var preload = new Image();
    preload.decoding = 'async';
    if (img.sizes) preload.sizes = img.sizes;
    if (img.srcset) preload.srcset = img.srcset;
    preload.src = source;
    if (preload.decode) preload.decode().catch(function() {});
    if (img.decode) img.decode().catch(function() {});
  }

  function getIndex(track) {
    var active = track.style.getPropertyValue('--active-slide');
    var parsed = parseInt(active, 10);
    if (!Number.isNaN(parsed)) return parsed;
    if (track.clientWidth) return Math.round(track.scrollLeft / track.clientWidth);
    return 0;
  }

  function primeAround(track, index, radius) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery-slide'));
    var start = Math.max(0, index - radius);
    var end = Math.min(slides.length - 1, index + radius);
    for (var i = start; i <= end; i += 1) {
      var img = slides[i] && slides[i].querySelector('img');
      primeImage(img, i <= 1);
    }
  }

  tracks.forEach(function(track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery-slide'));
    var mobileRadius = Math.max(2, slides.length);
    primeAround(track, 0, mobileQuery.matches ? mobileRadius : 1);

    var primeNext = function() {
      primeAround(track, getIndex(track), mobileQuery.matches ? mobileRadius : 2);
    };

    track.addEventListener('touchstart', primeNext, { passive: true });
    track.addEventListener('pointerdown', primeNext, { passive: true });
    track.addEventListener('scroll', function() {
      window.requestAnimationFrame(primeNext);
    }, { passive: true });
  });
})();

(function() {
  var page = document.querySelector('.sba-sales-page');
  if (!page) return;

  function imageDrawerIsOpen() {
    return !!document.querySelector('.image-drawer.open, .image-drawer.is-open, [data-image-drawer].open, [data-image-drawer].is-open, .product-image-drawer.open, .product-image-drawer.is-open');
  }

  function releaseGalleryLockForAccordion() {
    if (imageDrawerIsOpen()) return;
    document.body.classList.remove('gallery-locked');
    document.documentElement.classList.remove('gallery-locked');
  }

  page.addEventListener('click', function(event) {
    if (!event.target.closest('.product-accordion-trigger')) return;
    window.requestAnimationFrame(releaseGalleryLockForAccordion);
    window.setTimeout(releaseGalleryLockForAccordion, 80);
  }, true);

  page.addEventListener('touchstart', function(event) {
    if (event.target.closest('.product-accordion')) releaseGalleryLockForAccordion();
  }, { passive: true, capture: true });

  page.addEventListener('touchmove', function(event) {
    if (event.target.closest('.product-accordion')) releaseGalleryLockForAccordion();
  }, { passive: true, capture: true });

  document.addEventListener('shopify:section:load', releaseGalleryLockForAccordion);
  window.addEventListener('pageshow', releaseGalleryLockForAccordion);
})();


/* Aug 22 2026 — size guide opens in a modal on the sale PDPs instead of navigating away [13% quickback on the page visit] */
(function() {
  var page = document.querySelector('.sba-sales-page');
  if (!page || !window.fetch || !window.DOMParser) return;
  var CACHE_KEY = 'sba_sg_html_v1';
  var modal = null, lastFocus = null, loading = false;
  function build() {
    modal = document.createElement('div');
    modal.className = 'sba-sg-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Size guide');
    modal.innerHTML = '<div class="sba-sg-backdrop" data-sba-sg-close></div><div class="sba-sg-panel" tabindex="-1"><button type="button" class="sba-sg-close" data-sba-sg-close aria-label="Close size guide">&times;</button><div class="sba-sg-body"><div class="sba-sg-loading">loading the size guide</div></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function(e) { if (e.target.closest('[data-sba-sg-close]')) close(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }
  function open(link) {
    if (!modal) build();
    lastFocus = link;
    modal.classList.add('is-open');
    document.documentElement.classList.add('sba-sg-lock');
    modal.querySelector('.sba-sg-panel').focus();
    load(link);
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('sba-sg-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function render(html) {
    var body = modal.querySelector('.sba-sg-body');
    body.innerHTML = html;
  }
  function extract(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var wrap = doc.querySelector('.sg-wrap');
    if (!wrap) return null;
    var styles = [];
    var scope = wrap.parentElement || doc.body;
    scope.querySelectorAll('style').forEach(function(st) { styles.push(st.outerHTML); });
    wrap.querySelectorAll('script').forEach(function(sc) { sc.remove(); });
    return styles.join('') + wrap.outerHTML;
  }
  function load(link) {
    var cached = null;
    try { cached = sessionStorage.getItem(CACHE_KEY); } catch(e) {}
    if (cached) { render(cached); return; }
    if (loading) return;
    loading = true;
    fetch(link.getAttribute('href'), { credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
      .then(function(text) {
        var html = extract(text);
        if (!html) throw new Error('no size guide content');
        try { sessionStorage.setItem(CACHE_KEY, html); } catch(e) {}
        render(html);
      })
      .catch(function() {
        close();
        window.location.href = link.href;
      })
      .finally(function() { loading = false; });
  }
  document.addEventListener('click', function(e) {
    var link = e.target.closest ? e.target.closest('.sba-sales-page a.size-guide-link, .sba-sales-page a[href*="/pages/size-guide"]') : null;
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    open(link);
  }, true);
})();
